module.exports = __webpack_public_path__ + "static/media/119.2c18362.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/119.mp3
// module id = gzfN
// module chunks = 208